import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { StorageService } from "src/app/services/storage/storage.service";

@Component({
  selector: "app-card-wrapper",
  templateUrl: "./card-wrapper.component.html",
  styleUrls: ["./card-wrapper.component.scss"],
})
export class CardWrapper implements OnInit {
  @Input() data: any = {};
  @Input() type: string = "";
  @ViewChild("cardsWrapper", { static: false }) cardsWrapper: ElementRef;
  scrollX = 0;
  selectedFilter: string;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    const filter = this.storageService.get("filter");
    this.selectedFilter = filter;
  }

  moveCards = (type: string) => {
    let cardWidth = parseFloat(
      window
        .getComputedStyle(this.elementRef.nativeElement)
        .getPropertyValue("--card-width")
    );
    let scrollWidth =
      this.cardsWrapper.nativeElement.scrollWidth - cardWidth * 2;
    this.scrollX =
      type === "right" ? this.scrollX + cardWidth : this.scrollX - cardWidth;
    this.scrollX =
      this.scrollX < 0
        ? 0
        : this.scrollX > scrollWidth
        ? scrollWidth
        : this.scrollX;
    this.renderer.setProperty(
      this.cardsWrapper.nativeElement,
      "scrollLeft",
      this.scrollX
    );
  };
}
